import React from 'react';

const SvgNotificationWarning: React.FC<
  React.SVGProps<SVGSVGElement>
> = props => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="#FF8A43" fillRule="evenodd">
      <path
        d="M6.32 1.74L.846 10.857a1.938 1.938 0 00-.01 1.939c.343.602.984.978 1.682.985h10.959a1.965 1.965 0 001.69-.985 1.934 1.934 0 00-.006-1.93L9.68 1.74A1.964 1.964 0 008 .797c-.687 0-1.323.357-1.677.94l-.002.003zM8 2.11c.217 0 .42.113.533.301l5.474 9.114a.635.635 0 01-.539.944H2.524a.623.623 0 01-.528-.317.64.64 0 01.002-.636l5.47-9.106A.625.625 0 018 2.11z" // eslint-disable-line max-len
        fillRule="nonzero"
      />
      <path
        d="M7.333 5.388v2.58c0 .362.299.655.667.655a.662.662 0 00.667-.656V5.388A.662.662 0 008 4.732a.662.662 0 00-.667.656z"
        fillRule="nonzero"
      />
      <circle cx="8" cy="10.546" r="1" />
    </g>
  </svg>
);

export default SvgNotificationWarning;
